import { base } from './base'

export const secondaryInstructionsText = {
  ...base,
  fontSize: '1rem',
  marginTop: '0.5rem',
  marginBottom: '2rem',
  color: '#607C9F',
}

export const secondaryInstructionsLight = {
  ...secondaryInstructionsText,
  color: 'white',
}
